import axios from "axios";
import authHeader from "./auth-header";
import { config } from "../config";
import AuthService from "./auth.service";

class PatService {
  getAllStatus() {
    return axios
      .get(`${config.apiUrl}patOrganizer`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao buscar PATs:", err.response.data);
        return [];
      });
  }

  getPatsListStatus() {
    return axios
      .get(`${config.apiUrl}patOrganizer/patsListStatus`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao buscar PATs:", err.response.data);
        return [];
      });
  }

  statusToMap() {
    return axios
      .get(`${config.apiUrl}patOrganizer/statusToMap`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao buscar PATs:", err.response.data);
        return [];
      });
  }

  create(bodyParms) {
    return axios
      .post(`${config["apiUrl"]}pat`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 201) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  update(id, bodyParms) {
    return axios
      .patch(`${config["apiUrl"]}pat/${id}`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  createPat(data) {
    return axios.post(`${config.apiUrl}patOrganizer`, data, {
      headers: authHeader(),
    });
  }
  updatePat(id, data) {
    return axios.put(`${config.apiUrl}patOrganizer/${id}`, data, {
      headers: authHeader(),
    });
  }

  bulkChangeStatus(patIds, status) {
    return axios.patch(
      `${config.apiUrl}pat/bulk-status`,
      { pat_ids: patIds, status },
      { headers: authHeader() }
    );
  }

  async getByStatus(patId, page = 1) {
    const safeId = encodeURIComponent(patId.trim().replace(/,/g, "_"));
    const response = await axios.get(
      `${config.apiUrl}patOrganizer/${safeId}/status?page=${page}`,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  getInfo(nopat) {
    return axios
      .get(`${config.apiUrl}pat/${nopat}/info`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao buscar detalhes do PAT:", err);
        return null;
      });
  }

  getClients() {
    return axios
      .get(`${config.apiUrl}clients/getAll`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao buscar clientes:", err.response.data);
        return [];
      });
  }

  getTipos() {
    return axios
      .get(`${config.apiUrl}intervention/type`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao buscar tipos de intervenção:", err);
        return [];
      });
  }

  getEquipments() {
    return axios
      .get(`${config.apiUrl}equipments/getAll`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao buscar tipos de intervenção:", err);
        return [];
      });
  }

  getTechnicians() {
    return axios
      .get(`${config.apiUrl}user/technicians`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao buscar tipos de intervenção:", err);
        return [];
      });
  }

  getDepartments() {
    return axios
      .get(`${config.apiUrl}departments`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao buscar departamentos:", err);
        return [];
      });
  }

  getPublicStatus() {
    return axios
      .get(`${config.apiUrl}status-public`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao buscar status públicos:", err);
        return [];
      });
  }

  createWorkSheet(nopat) {
    return axios
      .post(
        `${config.apiUrl}pat/${nopat}/create-work-sheet`,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((r) => r.data);
  }

  createInstallationSheet(nopat) {
    return axios
      .post(
        `${config.apiUrl}pat/${nopat}/create-installation-sheet`,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((r) => r.data);
  }

  addLineToSheet(bostamp, data) {
    return axios
      .post(`${config.apiUrl}pat/${bostamp}/add-line`, data, {
        headers: authHeader(),
      })
      .then((r) => r.data);
  }

  updateLineToSheet(bostamp, data) {
    return axios
      .post(`${config.apiUrl}pat/${bostamp}/update-line`, data, {
        headers: authHeader(),
      })
      .then((r) => r.data);
  }

  removeLineFromSheet(recstamp) {
    return axios
      .delete(`${config.apiUrl}pat/dossier-line/${recstamp}`, {
        headers: authHeader(),
      })
      .then((r) => r.data);
  }

  getAllProducts() {
    return axios
      .get(`${config.apiUrl}products`, { headers: authHeader() })
      .then((r) => r.data);
  }

  updateSheetClosed(bostamp, closed) {
    return axios
      .put(
        `${config.apiUrl}pat/${bostamp}/update-closed`,
        { closed },
        {
          headers: authHeader(),
        }
      )
      .then((r) => r.data);
  }

  getBrandPats(brand) {
    return axios
      .get(`${config.apiUrl}pat/brand/${brand}`, {
        headers: authHeader(),
      })
      .then((r) => r.data);
  }

  getPatParts(pat) {
    return axios
      .get(`${config["apiUrl"]}/pat/${pat}/parts`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getMultipleStatus(status, brand) {
    return axios
      .get(`${config["apiUrl"]}pat/multipleStatus`, {
        headers: authHeader(),
        params: {
          status: status,
          brand: brand,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getInterventions(patId) {
    return axios
      .get(`${config["apiUrl"]}pat/${patId}/interventions`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getInstallationSheet(patId) {
    return axios
      .get(`${config["apiUrl"]}pat/${patId}/installationSheet`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getWorkSheet(patId) {
    return axios
      .get(`${config["apiUrl"]}pat/${patId}/workSheet`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getFiles(patId) {
    return axios
      .get(`${config["apiUrl"]}pat/${patId}/files`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  downloadAllFiles(patId) {
    return axios
      .get(`${config["apiUrl"]}pat/${patId}/files/download`, {
        headers: authHeader(),
        responseType: "blob",
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getLocalization(patId) {
    return axios
      .get(`${config["apiUrl"]}pat/${patId}/localization`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  updateLocalization(id, bodyParms) {
    return axios
      .patch(`${config["apiUrl"]}pat/${id}/localization`, bodyParms, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  search(term) {
    return axios
      .get(`${config["apiUrl"]}pat/search/${encodeURIComponent(term)}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  datatableFiltered(params) {
    return axios
      .get(`${config["apiUrl"]}pat/datatable/filtered`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  query(params) {
    return axios
      .get(`${config["apiUrl"]}pat/query`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  toogleShowList(id) {
    return axios
      .patch(
        `${config["apiUrl"]}patOrganizer/${encodeURIComponent(
          id
        )}/toogleShowList`,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  toogleShowMaps(id) {
    return axios
      .patch(
        `${config["apiUrl"]}patOrganizer/${encodeURIComponent(
          id
        )}/toogleShowMaps`,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  addFile(patId, photos) {
    let headers = authHeader();
    headers["Content-Type"] = "multipart/form-data";

    return axios
      .post(`${config["apiUrl"]}pat/${patId}/file`, photos, {
        headers: headers,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  addIntervention(id, params) {
    return axios
      .post(`${config["apiUrl"]}pat/${id}/intervention`, params, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  editIntervention(id, params) {
    return axios
      .put(`${config["apiUrl"]}pat/${id}/intervention`, params, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  exportContacts(patId) {
    return axios
      .get(`${config.apiUrl}pat/${patId}/exportContacts`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao buscar PATs:", err.response.data);
        return null;
      });
  }

  getComments(patId) {
    return axios
      .get(`${config.apiUrl}pat/comments/${patId}`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao buscar PATs:", err.response.data);
        return [];
      });
  }

  exportCSV(params) {
    return axios
      .get(`${config.apiUrl}pat/export/csv`, {
        headers: authHeader(),
        params: params,
        responseType: "blob",
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Erro ao exportar CSV:", err.response.data);
        return null;
      });
  }

  getByInternalStatesParentStatus(parentStatusId) {
    return axios
      .get(`${config["apiUrl"]}pat-internal-states/parent/${parentStatusId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        throw new Error("Failed to toggle active status");
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response?.data || error);
        throw new Error("Failed to toggle active status");
      });
  }

  createWarehouseTransferSheet(nopat) {
    return axios
      .post(
        `${config.apiUrl}pat/${nopat}/create-warehouse-transfer-sheet`,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((r) => r.data);
  }

  getWarehouseTransferSheet(patId) {
    return axios
      .get(`${config["apiUrl"]}pat/${patId}/warehouse-transfer-sheet`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  sendRequestEquipmentResourcesToClient(patId, data) {
    return axios
      .post(`${config["apiUrl"]}pat/${patId}/send-request-equipment-resources-to-client`, data, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getReportFile(patId, data) {
    return axios
      .post(`${config["apiUrl"]}pat/report/${patId}`, data, {
        headers: authHeader(),
        responseType: "blob",
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return null;
      });
  }

  // Recolha (Pickup) — 1:N
  getPickups(patId) {
    return axios
      .get(`${config.apiUrl}pat/${patId}/pickups`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return [];
      });
  }

  createPickup(patId, data) {
    return axios
      .post(`${config.apiUrl}pat/${patId}/pickups`, data, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }

  updatePickup(patId, id, data) {
    return axios
      .put(`${config.apiUrl}pat/${patId}/pickups/${id}`, data, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }

  deletePickup(patId, id) {
    return axios
      .delete(`${config.apiUrl}pat/${patId}/pickups/${id}`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }

  syncPickupStatus(patId, id) {
    return axios
      .get(`${config.apiUrl}pat/${patId}/pickups/${id}/sync`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }

  // Recepção (Reception) — 1:N
  getReceptions(patId) {
    return axios
      .get(`${config.apiUrl}pat/${patId}/receptions`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return [];
      });
  }

  createReception(patId, data) {
    return axios
      .post(`${config.apiUrl}pat/${patId}/receptions`, data, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }

  updateReception(patId, id, data) {
    return axios
      .put(`${config.apiUrl}pat/${patId}/receptions/${id}`, data, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }

  deleteReception(patId, id) {
    return axios
      .delete(`${config.apiUrl}pat/${patId}/receptions/${id}`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }

  // Envio (Dispatch) — 1:N
  getDispatches(patId) {
    return axios
      .get(`${config.apiUrl}pat/${patId}/dispatches`, { headers: authHeader() })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return [];
      });
  }

  createDispatch(patId, data) {
    return axios
      .post(`${config.apiUrl}pat/${patId}/dispatches`, data, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }

  updateDispatch(patId, id, data) {
    return axios
      .put(`${config.apiUrl}pat/${patId}/dispatches/${id}`, data, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }

  deleteDispatch(patId, id) {
    return axios
      .delete(`${config.apiUrl}pat/${patId}/dispatches/${id}`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }

  syncDispatchStatus(patId, id) {
    return axios
      .get(`${config.apiUrl}pat/${patId}/dispatches/${id}/sync`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }

  trackReception(patId, id) {
    return axios
      .get(`${config.apiUrl}pat/${patId}/receptions/${id}/track`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }

  getNotifyClientInfo(patId) {
    return axios
      .get(`${config.apiUrl}pat/${patId}/notify-client/info`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }

  sendNotifyClientEmail(patId, body) {
    return axios
      .post(`${config.apiUrl}pat/${patId}/notify-client/email`, body, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }

  sendNotifyClientSms(patId, body) {
    return axios
      .post(`${config.apiUrl}pat/${patId}/notify-client/sms`, body, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response?.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        throw err;
      });
  }
}

export default new PatService();
